import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

import { signUpPolicy } from '../auth/sign-up-policy.ts'
import { entryRoute } from './entry.tsx'
import { NAV_PATHS } from '../navigation/paths.ts'

// «Registra la tua società» lands here: on to the club's wizard, `replace`, while persons may not
// sign up (the door stays one step back); otherwise the fork. No session guard: nobody has an account yet.
export const signUpRoute = createRoute({
  getParentRoute: () => entryRoute,
  path: NAV_PATHS.signUp,
  beforeLoad: () => {
    if (!signUpPolicy.personsMaySignUp())
      throw redirect({ to: NAV_PATHS.signUpClub, replace: true })
  },
  component: lazyRouteComponent(() => import('../pages/sign-up.tsx')),
})
